import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BandForm } from "Bands/components";
import { clearActionMeta, createBand } from "Bands/state";
import { dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, IBand } from "Bands/types";

import { copy } from "shared/assets";
import { Band } from "shared/assets/icons";
import { Modal } from "shared/components";
import { IAPIState, IFormButtons, IStatus } from "shared/types";
import { BAND_PATHS } from "Bands/router";
import { addTemporaryToast } from "shared/components/Toast";
import { useBandRoute } from "Bands/utils";

const { createBand: createBandCopy } = copy;

interface CreateBandModalProps {
  handleClose: () => void;
}

export const CreateBandModal: FC<CreateBandModalProps> = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { pushRoute } = useBandRoute();

  const { api: apiMeta, id: bandId } = useSelector(dataMetaSelector(BAND_ACTIONS.createBand));

  const handleSubmit = (band: Partial<IBand>) => {
    dispatch(createBand(band));
  };

  const buttons: IFormButtons = {
    primary: {
      children: createBandCopy.submit.band,
      "data-testid": "create_band_button",
    },
    secondary: {
      onClick: handleClose,
    },
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded && bandId) {
      dispatch(clearActionMeta(BAND_ACTIONS.createBand));

      handleClose();

      pushRoute(BAND_PATHS.BAND_CALENDAR, {
        bandId,
      });

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: copy.createBand.success,
        })
      );
    }
  }, [bandId, apiMeta, handleClose, pushRoute, dispatch]);

  return (
    <Modal title={createBandCopy.title} icon={Band}>
      <BandForm
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        isSubmitting={apiMeta?.status === IAPIState.pending}
        hasError={!!apiMeta?.error}
        buttons={buttons}
        apiError={apiMeta?.error}
      />
    </Modal>
  );
};
